import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { VideoBlockResponse } from 'src/app/models/block-video';
import { BloqueVideo } from 'src/app/models/home-video';

import { environment as env } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HomeVideoService {
  private baseUrl = `${env.apiCerberoUrl}`;
  httpClient: any;
  constructor(private http: HttpClient) { }

  listarBloqueVideo(estado: string = 'activo', pagina: number = 1): Observable<BloqueVideo[]> {
    return this.http.get<BloqueVideo[]>(
      `${this.baseUrl}/request?event=listar-bloque-video&estado=${estado}&pagina=${pagina}`
    );
  }

  eliminarBloqueVideo(id: number): Observable<any> {
    return this.http.delete(`${this.baseUrl}/request?event=eliminar-bloque-video`, { body: { id } });
  }

  getSearchCriteria(criterio: string): Observable<VideoBlockResponse>{
    return this.http.get<VideoBlockResponse>(`${this.baseUrl}/request?event=buscar-bloque-video-por-criterio&criterio=${criterio}` );
  }
  

}
